/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateListResponse
 */
export interface CreateListResponse {
  /**
   *
   * @type {string}
   * @memberof CreateListResponse
   */
  companyListId: string;
}

/**
 * Check if a given object implements the CreateListResponse interface.
 */
export function instanceOfCreateListResponse(
  value: object,
): value is CreateListResponse {
  if (!("companyListId" in value) || value["companyListId"] === undefined)
    return false;
  return true;
}

export function CreateListResponseFromJSON(json: any): CreateListResponse {
  return CreateListResponseFromJSONTyped(json, false);
}

export function CreateListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateListResponse {
  if (json == null) {
    return json;
  }
  return {
    companyListId: json["companyListId"],
  };
}

export function CreateListResponseToJSON(json: any): CreateListResponse {
  return CreateListResponseToJSONTyped(json, false);
}

export function CreateListResponseToJSONTyped(
  value?: CreateListResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListId: value["companyListId"],
  };
}
